import { useQuery } from 'react-query';

import axiosClient from '../../../api/axios-client';
import { useTraductionsMetier } from '../../api/useTraductionsMetier';
import Text from '../../components/Text';
import { t } from '../../i18n/langue';

interface NoteChambre {
    id: number;
    content: string | null;
    user_name?: string | null;
}

/**
 * Les notes laissées sur la chambre par la gouvernante (« client allergique aux
 * plumes »), en lecture : traduites dans la langue de l'app (P1 du 28/10), le
 * français en petit dessous. Rien n'est affiché sans note.
 */
export default function BlocNotesChambre({ serviceId }: { serviceId: number }) {
    const { data } = useQuery(
        ['hk-room-notes', serviceId],
        async () => (await axiosClient.get<NoteChambre[]>(`/housekeeping/rooms/${serviceId}/notes`)).data,
        { staleTime: 60_000, refetchOnWindowFocus: false },
    );
    const notes = (data ?? []).filter((note) => note.content && note.content.trim() !== '');
    const traductions = useTraductionsMetier([], notes.map((note) => note.id));

    if (notes.length === 0) return null;

    return (
        <section className="flex flex-col gap-2">
            <Text variante="sousTitre" as="h2">
                {t('menage.notesChambre.titre')}
            </Text>
            {notes.map((note) => {
                const traduction = traductions.note(note.id);
                return (
                    <div key={note.id} className="rounded-xl bg-white px-3 py-2">
                        <Text className="whitespace-pre-line">{traduction ?? note.content}</Text>
                        {traduction && (
                            <Text variante="petit" ton="attenue" className="mt-1 whitespace-pre-line">
                                {note.content}
                            </Text>
                        )}
                        {note.user_name && (
                            <Text variante="petit" ton="attenue" className="mt-1">
                                {note.user_name}
                            </Text>
                        )}
                    </div>
                );
            })}
        </section>
    );
}
